export const GRANTED_PHYSICAL_TICKETS = 'physical_tickets'
export const GRANTED_DIGITAL = 'digital'
export const GRANTED_WILL_CALL_PICKUP = 'will_call_pickup'

export const TEVO_PHYSICAL = 'Physical'
export const TEVO_PAPERLESS = 'Paperless'

export const TEVO_ETICKET = 'Eticket'
export const TEVO_FLASH_SEATS = 'Flash_seats'
export const TEVO_TM_MOBILE = 'TM_mobile'
export const TEVO_TMMOBILE = 'TMMobile'

export const TEVO_GUEST_LIST = 'Guest_list'
export const TEVO_GUESTLIST = 'GuestList'

export const TEVO_OFFLINE = 'Offline'

export const ADDRESS_REQUIRED_OPTIONS = [GRANTED_PHYSICAL_TICKETS, TEVO_PHYSICAL, TEVO_PAPERLESS]
export const EMAIL_REQUIRED_OPTIONS = [
  GRANTED_DIGITAL,
  TEVO_ETICKET,
  TEVO_TMMOBILE,
  TEVO_TM_MOBILE,
  TEVO_FLASH_SEATS,
]
export const PHONE_REQUIRED_OPTIONS = [GRANTED_WILL_CALL_PICKUP, TEVO_GUESTLIST, TEVO_GUEST_LIST]
export const CC_ONLY_REQUIRED_OPTIONS = []

const TM_MOBILE_NOTES = (
  <>
    Tickets will be transferred to the email address you provide via Ticketmaster Mobile Transfer
    prior to the event, and we guarantee it. <br />
    <br /> To avoid your transfer from expiring, please accept your tickets within 7 days of
    receiving your transfer email. Have questions? Contact us at support@granted.co any time.
  </>
)

const GUESTLIST_NOTES = 'Your tickets will be available at will call on the night of the event.'

export const DELIVERY_OPTIONS_DEFAULT_NOTES = {
  [TEVO_PHYSICAL]: 'Physical tickets will be mailed to you.',
  [TEVO_ETICKET]: 'Tickets will be emailed to you.',

  [TEVO_FLASH_SEATS]:
    'Tickets will be transferred to the email address you provide via Flash Seats prior to the event, and we guarantee it. Have questions? Contact us at support@granted.co any time.',

  [TEVO_TMMOBILE]: TM_MOBILE_NOTES,
  [TEVO_TM_MOBILE]: TM_MOBILE_NOTES,

  [TEVO_GUESTLIST]: GUESTLIST_NOTES,
  [TEVO_GUEST_LIST]: GUESTLIST_NOTES,
}
